var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

define(function () {
  "use strict";

  return ["Top", "Right", "Bottom", "Left"];
});